import { render, staticRenderFns } from "./translationOpenDataText.vue?vue&type=template&id=d4cde790&scoped=true&"
import script from "./translationOpenDataText.vue?vue&type=script&lang=js&"
export * from "./translationOpenDataText.vue?vue&type=script&lang=js&"
import style0 from "./translationOpenDataText.vue?vue&type=style&index=0&id=d4cde790&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4cde790",
  null
  
)

export default component.exports